"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = {
    modelName: 'PaymentsForCustomer',
    tableName: 'PaymentsForCustomer',
    syncTableName: 'Payment',
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/paymentsForCustomer/modelProperties.js.map